import React from 'react'
import { createRoot } from 'react-dom/client'
import { Toaster } from 'sonner'
import MapWrapper from '@/features/dashboard/components/maps/map-wrapper'
import QueryProvider from '@/shared/components/query-provider'
import { SessionProvider } from '@/features/auth/context/session.context'
import { FeatureFlagsProvider } from '@/features/feature-flags/context/feature-flags-context'
import App from './App'
import '@/styles/globals.scss'

const WWW_HOST = 'www.reliefhub.app'

/**
 * Keep PWA registration on the canonical www host only. Cloudflare redirects
 * normal apex traffic; sw-apex-migrate.js handles apex clients controlled by
 * an old service worker that can bypass that edge redirect.
 */
async function initPwa(): Promise<void> {
  const { hostname } = window.location
  const shouldRegisterPwa =
    hostname === WWW_HOST ||
    hostname === 'localhost' ||
    hostname.endsWith('.pages.dev')

  if (shouldRegisterPwa && 'serviceWorker' in navigator) {
    try {
      // Generated by vite-plugin-pwa (includes sw-apex-migrate.js via importScripts).
      await navigator.serviceWorker.register('/sw.js', { scope: '/' })
    } catch {
      // PWA optional
    }
  }
}

const container = document.getElementById('root')
if (!container) {
  throw new Error('Failed to find the root element')
}

void initPwa()

const root = createRoot(container)
root.render(
  <React.StrictMode>
    <Toaster position="top-center" />
    <MapWrapper>
      <QueryProvider>
        <SessionProvider>
          <FeatureFlagsProvider>
            <App />
          </FeatureFlagsProvider>
        </SessionProvider>
      </QueryProvider>
    </MapWrapper>
  </React.StrictMode>
)
